import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_ScopeActions = _resolveComponent("ScopeActions")!
  const _component_ScopeTable = _resolveComponent("ScopeTable")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_ScopeParents = _resolveComponent("ScopeParents")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event)),
        density: "compact",
        "fixed-tabs": "",
        class: "rounded",
        style: {"background":"#f4f4f4"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "definition" }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("Périmètre")
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "usage" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Utilisation")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_text_field_filled, {
        modelValue: _ctx.companyScope.name,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyScope.name) = $event)),
          _cache[2] || (_cache[2] = ($event: any) => {
                    _ctx.nameSync = $event;
                    _ctx.namedScope = !!$event;
                })
        ],
        label: "Nom du périmètre",
        density: "compact"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, { value: 'definition' }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_ScopeActions, _mergeProps({
                  search: _ctx.search,
                  "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event))
                }, _ctx.companyScope, {
                  "hide-company": _ctx.hideCompany,
                  "hide-activity": _ctx.hideActivity,
                  "hide-tax-system": _ctx.hideTaxSystem
                }), null, 16, ["search", "hide-company", "hide-activity", "hide-tax-system"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_ScopeTable, _mergeProps({
                  search: _ctx.search,
                  "onUpdate:search": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event))
                }, _ctx.companyScope), null, 16, ["search"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, { value: 'usage' }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_ScopeParents, _mergeProps({
                  search: _ctx.search,
                  "onUpdate:search": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event))
                }, _ctx.companyScope), null, 16, ["search"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}